module.exports = __webpack_public_path__ + "img/letras.0e8d8f17.png";